<div class="welcome-layout">
  <div class="fx-row fx-gap-1-rem fx-justify-center fx-items-center container">
    <h1 i18n>Enterprise Investor configuration</h1>
  </div>
</div>
